// @flow

export type MouseHelperOptions = {
    onMove: Function,
    onStop: Function,
    millisecondsToDetectStop?: number
};

const defaultMillisecondsToDetectStop = 500;

export default class MouseHelper {
    timer: TimeoutID;
    options: MouseHelperOptions;

    static init(options: MouseHelperOptions) {
        new this(options);
    }

    static isWithinBounds(x: number, y: number, bounds: ClientRect) {
        return (
            x >= bounds.left &&
            x <= bounds.left + bounds.width &&
            y >= bounds.top &&
            y <= bounds.top + bounds.height
        );
    }

    constructor(options: MouseHelperOptions) {
        this.options = options;
        document.addEventListener("mousemove", (event: MouseEvent) =>
            this.trigger(event)
        );
    }

    trigger(event: MouseEvent) {
        if (!!this.timer) {
            clearTimeout(this.timer);
        }

        if (this.options.onMove) {
            this.options.onMove(event);
        }

        this.timer = setTimeout(() => {
            if (this.options.onStop) {
                this.options.onStop(event);
            }
        }, this.timeToDetectStop);
    }

    get timeToDetectStop(): number {
        return (
            this.options.millisecondsToDetectStop ||
            defaultMillisecondsToDetectStop
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/util/MouseHelper.js